<template>
    <li class="h-fit">
      <NuxtLink v-if="url" class="link flex gap-x-1 items-center whitespace-nowrap" :to="url" external>
        {{label}}
        <div v-if="tag" class="rounded-full text-sm text-center px-3 py-1 text-white"
             :style="getLinkTagStyling">
          {{tag}}
        </div>
      </NuxtLink>
    </li>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { type BuilderNavLink } from '../organism/navBar.vue';

const {
  label,
  url,
  tag = '',
  tagTextColor = 'white',
  tagBackgroundColor = 'none',
} = defineProps<BuilderNavLink>();

// can't use dynamic classes with tailwind, have to use styling
const getLinkTagStyling = computed(() => {
  return {color: tagTextColor || 'white', backgroundColor: tagBackgroundColor || 'none'};
})

</script>
